import { GetterTree } from "vuex";
import { RootState } from "../types";
import { BundleCourseState } from "./types";

export const getters: GetterTree<BundleCourseState, RootState> = {};
